import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { IsNotMidnightPipe } from '../../../../../pipes/is-not-midnight.pipe';
import { timeFormat } from '../../../../../models/date-formats';

@Pipe({
  name: 'dateTimeFormat',
  standalone: true
})
export class DateTimeFormatPipe implements PipeTransform {
  constructor(
    private datePipe: DatePipe,
    private isNotMidnight: IsNotMidnightPipe
  ) {}

  transform(value: string | null): string {
    if (!value) {
      return '';
    }

    const dateStr = this.datePipe.transform(value) ?? '';

    if (!this.isNotMidnight.transform(value)) {
      return dateStr;
    }

    const timeStr = this.datePipe.transform(value, timeFormat) ?? '';
    return `${dateStr} ${timeStr}`;
  }
}
